<template>
  <div
    style="position: fixed; z-index: 9999; width: 100%"
    :class="{ 'fixed m-auto bg-[rgba(0,0,0,0.9)] w-full z-[999999]': isFixed }"
  >
    <div class="navbar container py-5 z-50 relative">
      <div class="flex items-center justify-between">
        <nav class="">
          <router-link class="h-24 mx-w-[200px]" exact to="/">
            <img
              class="object-center object-fill"
              src="@/assets/images/Logo.svg"
              alt=""
            />
          </router-link>
          <div></div>
          <div></div>
        </nav>
        <!-- start-links -->
        <div>
          <ul
            @click="toggleMenu"
            class="navbar-links list-none flex gap-10 justify-between items-center lg:flex md:hidden sm:hidden xs:hidden"
          >
            <li
              role="button"
              class="font-normal lg:text-lg md:text-sm relative"
            >
              Features
              <img
                :class="
                  menu
                    ? 'inline-block transition transform rotate-180'
                    : 'inline-block transition'
                "
                src="@/assets/images/down_arrow.svg"
              />
              <div v-if="menu" class="features-menu px-10 py-10 cursor-default">
                <div class="grid grid-cols-3 justify-center">
                  <div class="first-col">
                    <h1 class="head-title mb-3">Client Management</h1>
                    <ul class="list-none">
                      <li class="flex items-start gap-3 mb-6">
                        <img class="mt-2" src="@/assets/images/Diet.svg" />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Diet</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                      <li class="flex items-start gap-3 mb-6">
                        <img class="mt-2" src="@/assets/images/Workout.svg" />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Workout</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                      <li class="flex items-start gap-3 mb-6">
                        <img class="mt-2" src="@/assets/images/Exercise.svg" />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Exercise</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <h1 class="head-title mb-3">Client Engagement</h1>
                    <ul class="list-none">
                      <li class="flex items-start gap-3 mb-6">
                        <img
                          class="mt-2"
                          src="@/assets/images/Client managment system.svg"
                        />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Client Management System</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                      <li class="flex items-start gap-3 mb-6">
                        <img class="mt-2" src="@/assets/images/Workout.svg" />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Workout</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                      <li class="flex items-start gap-3 mb-6">
                        <img class="mt-2" src="@/assets/images/Exercise.svg" />
                        <div class="flex-col gap-y-2 px-2">
                          <h4>Exercise</h4>
                          <span
                            class="text-left text-[#808080] text-[14px] line-clamp-2"
                            >Lorem Ipsum is simply dummy text of the printing
                            and typesetting.</span
                          >
                        </div>
                      </li>
                    </ul>
                  </div>
                  <div>
                    <div class="">
                      <h1 class="head-title">Business Growth</h1>
                      <ul class="list-none">
                        <li class="flex items-start gap-3 mb-6">
                          <img
                            class="mt-2"
                            src="@/assets/images/Personal branding.svg"
                          />
                          <div class="flex-col gap-y-2 px-2">
                            <h4>Personal Branding</h4>
                            <span
                              class="text-left text-[#808080] text-[14px] line-clamp-2"
                              >Lorem Ipsum is simply dummy text of the printing
                              and typesetting.</span
                            >
                          </div>
                        </li>
                        <li class="flex items-start gap-3 mb-6">
                          <img
                            class="mt-2"
                            src="@/assets/images/Fast delivery.svg"
                          />
                          <div class="flex-col gap-y-2 px-2">
                            <h4>Fast Delivery</h4>
                            <span
                              class="text-left text-[#808080] text-[14px] line-clamp-2"
                              >Lorem Ipsum is simply dummy text of the printing
                              and typesetting.</span
                            >
                          </div>
                        </li>
                        <li class="flex items-start gap-3 mb-6">
                          <img
                            class="mt-2"
                            src="@/assets/images/svgexport-7 (9) 1.svg"
                          />
                          <div class="flex-col gap-y-2 px-2">
                            <h4>Analysis</h4>
                            <span
                              class="text-left text-[#808080] text-[14px] line-clamp-2"
                              >Lorem Ipsum is simply dummy text of the printing
                              and typesetting.</span
                            >
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li class="font-normal lg:text-lg md:text-sm">Case</li>
            <li class="font-normal lg:text-lg md:text-sm">Pricing</li>
            <li class="font-normal lg:text-lg md:text-sm">Our Blog</li>
            <li class="font-normal lg:text-lg md:text-sm">About Us</li>
            <li class="font-normal lg:text-lg md:text-sm">Contact Us</li>
          </ul>
        </div>
        <!-- end-links -->
        <div class="flex gap-3">
          <div
            role="button"
            class="login-btn-modal relative flex lg:flex md:hidden sm:hidden"
          >
            <svg
              class="h-[50px]"
              xmlns="http://www.w3.org/2000/svg"
              width="111"
              height="52"
              viewBox="0 0 111 52"
              fill="none"
            >
              <path d="M1 1H110V39L98 51H1V1Z" stroke="#FFF000" />
            </svg>
            <h3
              class="w-full h-full absolute flex items-center justify-center text-[16px] text-[#FFF000] gap-2"
            >
              Login
              <img src="@/assets/images/Arrow 4.svg" />
            </h3>
          </div>
          <button
            class="round-btn lg:flex md:hidden sm:hidden xxs: relative outline-none flex items-center gap-2 border-[#FFF000] text-[16px] text-black font-semibold px-5 bg-[#FFF000]"
          >
            Get Started
            <img src="@/assets/images/Arrow 4black.svg" />
          </button>
        </div>
        <!-- mobile -->
        <svg
          @click="togglemenuslide"
          data-v-4fa0a2a1=""
          data-v-c853113a=""
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          aria-hidden="true"
          role="button"
          class="icon-Sidemenu"
          width="40px"
          height="40px"
          viewBox="0 0 24 24"
          style="color: var(--primary)"
        >
          <path
            fill="currentColor"
            d="M3 18v-2h18v2H3Zm0-5v-2h18v2H3Zm0-5V6h18v2H3Z"
          ></path>
        </svg>
        <!-- mobile -->
      </div>
    </div>
  </div>
  <Teleport to="#mobile">
    <SideMenu :show="menuslide" @hide="togglemenuslide" />
  </Teleport>
  <router-view />
</template>
<script>
import { ref, onMounted, onUnmounted } from "vue";
import SideMenu from "@/components/Sidemenu/index.vue";

export default {
  name: "nav-bar",
  components: {
    SideMenu,
  },
  setup() {
    // toggle menu
    const menu = ref(false);
    const toggleMenu = () => {
      menu.value = !menu.value;
    };
    const menuslide = ref(false);
    const togglemenuslide = () => {
      menuslide.value = !menuslide.value;
    };

    // for fixed navbar
    const isFixed = ref(false);

    const handleScroll = () => {
      isFixed.value = window.scrollY > 0;
    };

    onMounted(() => {
      window.addEventListener("scroll", handleScroll);
    });

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll);
    });
    return {
      toggleMenu,
      isFixed,
      menuslide,
      menu,
      handleScroll,
      togglemenuslide,
    };
  },
};
</script>
